import React from 'react';

import Footer from '../components/Footer';
import Header from '../components/Header'
const TermsOfUse = () => (
  <>
    <Header />
    <main style={mainStyle}>
      <h1>Terms of Use</h1>
      <p><strong>Effective Date:</strong> August 5, 2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By using CurrentJobs.co.ke ("we", "us", "our"), you agree to these Terms. If you disagree, please cease use immediately.</p>

      <h2>2. Permitted Use</h2>
      <ul>
        <li>Access and browse our job listings for **personal, non-commercial use** only.</li>
        <li>You may **view, print, and share** job posts freely, provided you do not modify them or use them commercially.</li>
        <li>Unpermitted uses: scraping, copying in bulk, reproducing for resale, or using for spam or unsolicited outreach.</li>
      </ul>

      <h2>3. Job Listings & Accuracy</h2>
      <p>We collect and display postings from public or partner sources. While we review content regularly, we do <strong>not guarantee accuracy, completeness, or availability.</strong></p>
      <p>We assume no liability for any job application, employer interaction, or outcome.</p>

      <h2>4. Copyright & Infringement</h2>
      <p>Third-party listings remain the property of their original creators. If you believe your content has been used improperly, send a takedown request to <a href="mailto:info@currentjobs.co.ke">info@currentjobs.co.ke</a> including:</p>
      <ul>
        <li>Your name and contact details</li>
        <li>Link or description of the infringing content</li>
        <li>Proof of ownership or authorization</li>
        <li>A statement affirming your claim's accuracy</li>
      </ul>
      <p>We will investigate and remove content as needed. Repeat infringers may be blocked.</p>

      <h2>5. No Charges or Fees</h2>
      <p>We do not charge users to view, share, or apply for jobs. If any entity linked from our site requests payment, **do not pay**, and contact us immediately.</p>

      <h2>6. User Responsibilities & Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use automated bots, scraping tools, or excessive requests</li>
        <li>Engage in fraudulent, discriminatory, or unlawful behavior</li>
        <li>Post false or misleading content or impersonate others</li>
      </ul>

      <h2>7. Limitation of Liability</h2>
      <ul>
        <li>We operate the site "as-is" and disclaim all warranties (express or implied).</li>
        <li>Under no circumstances shall CurrentJobs.co.ke, its affiliates or contributors be liable for any indirect, incidental, special or consequential damages.</li>
      </ul>

      <h2>8. Changes to Site or Terms</h2>
      <p>We may modify the site, these Terms, or any other documents at any time. Your continued use constitutes acceptance.</p>

      <h2>9. Governing Law & Dispute Resolution</h2>
      <p>These Terms are governed by the laws of Kenya, including the Constitution of Kenya and the Data Protection Act, 2019. Any disputes will be resolved in Kenyan courts.</p>

    </main>
    <Footer />
  </>
);

const mainStyle = { padding: '2rem', maxWidth: '800px', margin: 'auto', lineHeight: 1.6 };

export default TermsOfUse;
